module.exports = __webpack_public_path__ + "static/media/services5.eff1e101.png";